import { reactive } from 'cdui-js';

/**
 * 防重复提交锁：请求进行中拒绝再次进入，结束后自动解锁。
 * UI 用 lock.submitting 控制 disabled / open-progress-interact-disabled。
 */
export const createSubmitLock = () => {
  const lock = reactive({ submitting: false });

  const run = async <T>(fn: () => T | Promise<T>): Promise<T | undefined> => {
    if (lock.submitting) return;
    lock.submitting = true;
    try {
      return await fn();
    } finally {
      lock.submitting = false;
    }
  };

  return { lock, run };
};
